import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { LoadingButton } from '@atlaskit/button';

import { useIntl } from '@atlassian/jira-intl';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { type SortIssuesDropdown, SortOrderIcon } from './sorting-dropdown/SortIssuesDropdown.tsx';
import messages from './sorting-dropdown/messages.tsx';
import { useCurrentSortOptions } from './sorting-dropdown/utils.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazySortIssues = lazy<typeof SortIssuesDropdown>(() =>
	import(
		/* webpackChunkName: "async-version-detail-sort-issues" */ './sorting-dropdown/SortIssuesDropdown.tsx'
	).then((module) => module.SortIssuesDropdown),
);

export const AsyncSortIssues = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const { currentSortByOption, currentSortOrderOption } = useCurrentSortOptions();

	return (
		<Placeholder
			name="version-detail-sort-issues"
			fallback={
				<StyledButton iconAfter={<SortOrderIcon order={currentSortOrderOption.id} />}>
					{/* eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx */}
					{`${formatMessage(messages.sortBy)}: ${formatMessage(currentSortByOption.label)}`}
				</StyledButton>
			}
		>
			<LazySortIssues />
		</Placeholder>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const StyledButton = styled(LoadingButton)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		display: 'flex',
		alignItems: 'center',
		font: token('font.body'),
		fontWeight: token('font.weight.medium'),
	},
});
